var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashBin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7904 5.5H3.20703",
    stroke: "#2D334E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2622 7.7915L16.8405 14.1157C16.6783 16.5494 16.5972 17.7662 15.8042 18.508C15.0113 19.2498 13.7918 19.2498 11.3527 19.2498H10.6438C8.20474 19.2498 6.9852 19.2498 6.19228 18.508C5.39935 17.7662 5.31823 16.5494 5.15599 14.1157L4.73438 7.7915",
    stroke: "#2D334E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95703 5.5C6.00825 5.5 6.03387 5.5 6.05708 5.49941C6.81191 5.48028 7.4778 5.00033 7.73465 4.29029C7.74255 4.26845 7.75065 4.24415 7.76684 4.19556L7.85584 3.92857C7.93181 3.70066 7.9698 3.58669 8.02019 3.48993C8.22121 3.1039 8.59313 2.83583 9.02292 2.7672C9.13065 2.75 9.25077 2.75 9.49102 2.75H12.5064C12.7466 2.75 12.8667 2.75 12.9745 2.7672C13.4043 2.83583 13.7762 3.1039 13.9772 3.48993C14.0276 3.58669 14.0656 3.70065 14.1416 3.92857L14.2306 4.19556C14.2467 4.24409 14.2549 4.26847 14.2627 4.29029C14.5196 5.00033 15.1855 5.48028 15.9403 5.49941C15.9635 5.5 15.9891 5.5 16.0404 5.5",
    stroke: "#2D334E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBin);
export default __webpack_public_path__ + "static/media/TrashBin.f66657650147e23a24673c91704430de.svg";
export { ForwardRef as ReactComponent };